import { GET, POST, PUT } from '@/admin-shared-modules/utils/ajax'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'

export const DevicesOfTemplate = [
  'X1M',
  'P7MC',
  'P10M',
  'P10MP',
  'P78DCA',
  'P10D'
] as const

export type TemplateData = {
  title: string
  devices: Partial<typeof DevicesOfTemplate>[]
  template: Schema | null
}

export type Schema = {
  name: string
  sections: Section[]
}

export type Section = BannerSection | AppSection

export type BannerSection = {
  type: 'banner'
  images: string[]
  duration: number
}

export type AppSection = {
  type: 'apps'
  name: string
  columns: number
  data: App[]
}

export type App = {
  type: 'libApp' | 'libResource' | 'apk' | 'web'
  libResourceKey?: string
  libAppKey?: number

  name: string
  alias?: string
  icon?: string
  url?: string
  note?: string
  zoom?: number
  showControl?: boolean
}

export function createSchema(): Schema {
  return {
    name: '',
    sections: [
      {
        type: 'banner',
        images: [],
        duration: 10
      },
      {
        type: 'apps',
        name: '模块名称',
        columns: 2,
        data: []
      }
      //   {
      //     type: 'apps',
      //     name: '1',
      //     columns: 2,
      //     data: [
      //       {
      //         type: 'buildIn',
      //         name: '书城',
      //         icon: '//placehold.it/200x200'
      //       },
      //       {
      //         type: 'web',
      //         name: 'web',
      //         icon: '//placehold.it/200x200',
      //         url: 'https://www.baidu.com'
      //       },
      //       {
      //         type: 'apk',
      //         icon: '//placehold.it/200x200',
      //         name: 'apk',
      //         url: 'https://www.baidu.com'
      //       }
      //     ]
      //   },
      //   {
      //     type: 'apps',
      //     name: '阅读评价',
      //     columns: 1,
      //     data: [
      //       {
      //         type: 'web',
      //         icon: '//placehold.it/200x200',
      //         name: '2',
      //         url: 'https://www.baidu.com'
      //       },
      //       {
      //         type: 'web',
      //         icon: '//placehold.it/200x200',
      //         name: '2',
      //         url: 'https://www.baidu.com'
      //       },
      //       {
      //         type: 'web',
      //         icon: '//placehold.it/200x200',
      //         name: '2',
      //         url: 'https://www.baidu.com'
      //       }
      //     ]
      //   },
      //   {
      //     type: 'apps',
      //     name: '3',
      //     columns: 1,
      //     data: []
      //   },
      //   {
      //     type: 'apps',
      //     name: '4',
      //     columns: 2,
      //     data: []
      //   }
    ]
  }
}

export const useStore = () => {
  const route = useRoute()
  const id = computed(() => route.params.id as string)
  const isEdit = computed(() => id.value !== '0')
  const router = useRouter()

  const data = ref<TemplateData>()
  const schema = ref<Schema>(createSchema())
  const loading = ref(true)

  async function fetch() {
    const res = await GET(`homepage_template/${id.value}`, {})
    data.value = res.data
    schema.value = data.value.template
    loading.value = false
  }
  onMounted(() => {
    if (!isEdit.value) {
      const schema = createSchema()
      data.value = {
        title: '新建模板',
        devices: [],
        template: schema
      }
    } else {
      fetch()
    }
  })

  async function submit() {
    const json = {
      ...data.value,
      template: schema.value
    }

    if (!isEdit.value) {
      const { data } = await POST('homepage_template', {
        data: json
      })
      router.replace({
        name: 'deviceHomePageTemplateEdit',
        params: {
          id: data.id
        }
      })
    } else {
      await PUT(`homepage_template/${id.value}`, {
        data: json
      })
    }
  }

  return {
    loading,
    data: schema,
    originalData: data,
    submit
  }
}
